import env from 'react-dotenv';

export const rollbarConfig = {
  accessToken: env.ROLLBAR_TOKEN,
  environment: process.env.NODE_ENV ?? 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
};
